<template>
  <div class="ex-checkpoint-badge">
    <v-chip :class="classes">
        <span :class="textClasses" class="prop-status-label">{{ levelLabel }} Level</span>
    </v-chip>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { getBadgeLevelDisplayLabel, isBadgeLevelValue, normalizeBadgeLevel } from "@components/utils/normalizeBadgeLevel";
// Props definition
const props = defineProps({
  level: {
    type: String,
    validator: function (value) {
      return typeof value === 'string' && isBadgeLevelValue(value) && normalizeBadgeLevel(value) !== 'novice';
    },
  }
});

const levelLabel = computed(() => getBadgeLevelDisplayLabel(props.level) || props.level);

const classes = computed(() => {
  const levelClass = `checkpoint-badge--${levelLabel.value}`;
  return {
    [levelClass]: true,
  };
});

const textClasses = computed(() => {
  return {
    [`checkpoint-text--${levelLabel.value}`]: true,
  };
});
</script>

<style>
.ex-checkpoint-badge {
  display: flex;
  align-items: center;
}

.ex-checkpoint-badge .checkpoint-badge--Apprentice {
  border-radius: 8px !important;
  border: 1px solid;
  border-color:#E58700 !important;
  background-color: #FFF5D3 !important;
  padding: 18px 36px;
}

.ex-checkpoint-badge .checkpoint-badge--Proficient {
  border-radius: 8px !important;
  border: 1px solid;
  border-color: #00B813 !important;
  background-color: #F3FFF9 !important;
  padding: 18px 32px;
}

.ex-checkpoint-badge .checkpoint-badge--Coach {
  border-radius: 8px !important;
  border: 1px solid;
  border-color: #00A3FF !important;
  background-color: #EFFEFF !important;
  padding: 18px 49px;
}

.ex-checkpoint-badge .checkpoint-badge--Architect {
  border-radius: 8px !important;
  border: 1px solid;
  border-color: #2E1EC1 !important;
  background-color: #F2F3FF !important;
  padding: 18px 47.5px;
}

.ex-checkpoint-badge .checkpoint-text--Apprentice {
  color: #E58700 !important;
}

.ex-checkpoint-badge .checkpoint-text--Proficient {
  color: #00B813 !important;
}

.ex-checkpoint-badge .checkpoint-text--Coach {
  color: #00A3FF !important;
}

.ex-checkpoint-badge .checkpoint-text--Architect {
  color: #2E1EC1 !important;
}

.ex-checkpoint-badge .prop-status-label {
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: center;
}

.checkpoint-badge--Apprentice:hover:before {
  opacity: 0 !important;
}

.checkpoint-badge--Proficient:hover:before {
  opacity: 0 !important;
}

.checkpoint-badge--Coach:hover:before {
  opacity: 0 !important;
}

.checkpoint-badge--Architect:hover:before {
  opacity: 0 !important;
}
</style>

  